import "react-app-polyfill/ie11";
import "core-js/stable";
import { hooks } from "botframework-webchat-component";
import React, { useRef, useCallback, useState, useContext, useEffect } from "react";
import Attachment from "./Attachment";
import SuggestedActions from "./SuggestedActions";
import getValueOrUndefined from "../util/getValueOrUndefined";
import MenuIcon from "../images/svgLatest/MenuIcon_HBT.svg";
import { debounce } from "throttle-debounce";
import useKeyPress from "./useKeyPress";
import Markdown from "markdown-to-jsx";
import { getSuggestedInput,fileToBase64,sendToUploadAPI } from "../util/httprequest";
import "../css/three-dots.css";
import DOMPurify from "dompurify";
import setLastMessage from "../util/setLastMessage";
import { AppContext } from "../../src/util/appContext";
import TimerBox_Main from "./TimerBox_Main";
import TimerBoxHBT from "./TimerBox_HBT";
import StaticLabels from "../util/staticLabels.json";
import {  getCookie } from '../util/cookieActions';
import Restart_HBT from '../images/svgLatest/Restart_HBT.svg';
import LiveAgent_HBT from '../images/svgLatest/LiveAgent_HBT.svg';
import CloseMenu_HBT from '../images/svgLatest/CloseMenu_HBT.svg';
import Spinner from "./Spinner";
import CharCounterInput from "./CharCounterInput";
import AttachmentIcon from '../images/attach.svg';
import AttachmentFile from './AttachmentFile';
import getCWACookies from "../util/getCWACookies";
var classNames = require("classnames");
function scrollDown(bodyRef) {
  let a = document.getElementById("web-chat")
    ? (document.getElementById("web-chat").scrollTop = document.getElementById(
      "web-chat"
    ).scrollHeight)
    : "";
  a = bodyRef.current
    ? (bodyRef.current.scrollTop = bodyRef.current.scrollHeight)
    : "";
  a = "";
  return a;
}

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function mapErrorCodeToBanner(code,sizeTitle,sizeMessage,typeTitle,typeMessage,systemTitle,systemMessage){
    if(code === 'size') {
      return { kind: 'size', title: sizeTitle, body: sizeMessage };
    }
    else if(code === 'type') {
      return { kind: 'type', title: typeTitle, body:typeMessage};
    }
    else{
      return { kind: 'type', title: systemTitle, body: systemMessage};
    }
   }
  function truncate(name, n = 28){
    return name.length > n ? name.slice(0, n-3) + '...' : name;
  }

const { useActivities, useSendMessage, useActiveTyping, useSendMessageBack, useSendEvent } = hooks;

const PlainWebChat = ({
  isMaximised,
  isLiveAgent,
  handleModalChange,
  handleMaximizeChange,
  handleCloseModalPopup,
  appInsights,
  showSendBox,
  showTimerBox,
  setShowTimerBox,
  userLanguage,
  handleSurveyCardChange,
  setHeaderIconsDisplay,
  setLiveAgent,
  headerRef,
  isSurveyOpen
}) => {
  const [activities] = useActivities();
  const [latestActivity] = [...activities].slice(-1);
  const anchorId =latestActivity.id;

  const ATTACHMENTS_KEY =window.config.businessUnit+'_dca_persisted_attachments';

  function loadPersistedAttachments() {
    try {
      return JSON.parse(sessionStorage.getItem(ATTACHMENTS_KEY) || '[]');
    } catch {
      return [];
    }
  }

function savePersistedAttachments(list) {
  sessionStorage.setItem(ATTACHMENTS_KEY, JSON.stringify(list || []));
}

  const [persistedAttachments, setPersistedAttachments] = React.useState(
    () => loadPersistedAttachments()
  )
 const activitiesWithPreview = React.useMemo(() => {
  const persistedAttachmentActivities = Array.isArray(persistedAttachments)
    ? persistedAttachments
        .filter(att => att && att.contentUrl)
        .map(att => ({
          id: att.id,
          type: 'message',
          from: { role: 'user' },
          timestamp: att.timestamp,
          attachments: [
            {
              contentType: att.contentType,
              contentUrl: att.contentUrl,
              name: att.name,
            },
          ],
        }))
    : [];

  // combine chat activities + our attachment activities
  const combined = [...activities, ...persistedAttachmentActivities];

  // sort oldest -> newest
  combined.sort((a, b) => {
    if (!a.timestamp || !b.timestamp) return 0;
    const ta = new Date(a.timestamp).getTime();
    const tb = new Date(b.timestamp).getTime();
    return ta - tb;
  });

  return combined;
}, [activities, persistedAttachments]);

  const [typingIndicator] = useActiveTyping(5000);
  const sendMessage = useSendMessage();
  const sendEvent = useSendEvent();
  const sendMessageBack = useSendMessageBack();
  const textInput = React.useRef(null);

  const [sendBoxValue, setSendBoxValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);

  const [file, setFile] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [uploading, setUploading] =useState(false);
  const [uploadNotice, setUploadNotice] =useState(null);
  const fileInputRef = useRef(null);
  const textInputRef = useRef(null);
  
  function onFilePick(e){
  console.log("onFilePick Fired")
  const f = e.target.files && e.target.files[0];
  if (!f) return;

  setFile(f);
  context.setDisableSendBox(false);
  setSendBoxValue(f? f.name:"");
  setUploadNotice(null);
    if (textInput.current) {
    textInput.current.focus();    //added this as when we select a file focus should be back on the
  }
 }

  // state to store customer typing event
  const [typingTimeout, setTypingTimeout] = useState(null)
  const context = useContext(AppContext);
    context.setShowSpinnerWheelOnload(true);
  const isValidAnonymousPageTitle = (getCookie(window.config.businessUnit + '-AuthToken') == "Anonymous") ? true : false;
  const isNoLiveAgentChat = (window.config.pageTitle?.includes("gamewell") || window.config.pageTitle?.includes("farenhyt") || window.config.pageTitle?.includes("honSec"))? true : false;

  useKeyPress(setSearchResult);
  var botAvatar = classNames({
    botAvatarClass: true
  });
    var textAreaMaxLimit = classNames({
        maxLimit: true,
        textareaMax:window.config.isTextArea?true:false
      });
  var attachClass = classNames({
    displayNone: window.config.businessUnit=="HBT-GCEGBT" && !window.config.isChina &&  (context.enableSendBoxHBT || !context.disableSendBox) && context.isLiveAgent && getCookie(window.config.businessUnit + '-AuthToken') != "Anonymous" ?false:true,
    attachbtn:true
  });
  var liveAgentIcon = classNames({
    liveAgentIcon: true
  });
  var Icon = classNames({
    Icon: true
  });
  const bodyRef = React.useRef();
  scrollDown(bodyRef);
  const debounceFun = debounce(200, async (searchValue, debounceFun) => {
    console.log( window.config.disableSuggest);
    let suggestedInput = [];
    if(searchValue &&  window.config.disableSuggest === false && window.config.gbe !== 'PSS' && window.config.gbe !== 'HPS' && window.config.language === "en") {
      suggestedInput = await getSuggestedInput(searchValue, appInsights);
    } else {
      setTimeout(() => {
        setSearchResult([]);
      }, 2000);
    }
    if (suggestedInput) {
      let suggestedInputResults = [];
      suggestedInput.map(item =>
        suggestedInputResults.push({
          "intent": item["intent"], "suggestedText": item["@search.text"].replace(
            new RegExp(searchValue, "ig"),
            `**${searchValue}**`
          )
        })
      );
      setSearchResult(suggestedInputResults);
    } else {
      setSearchResult([]);
    }
  });

  const handleDebounce = React.useRef(debounceFun);

  const handleChange = useCallback(
    ({ target: { value } }) => {
      if (file) { setSendBoxValue(file.name); return false } // Allow text input only if no file is selected    }
      //console.log("11")
      // disabling typing indicator for any accidental issues.
      if (window.config.businessUnit === "HBT-GCEGBT" && context.isLiveAgent) {
        window.config.showTypingIndicator = false;
      }

      const anonymousCheck=(window.config.businessUnit=="HBT-GCEGBT" && (getCookie(window.config.businessUnit + '-AuthToken') == "Anonymous" || window.config.isBrandBasedPage));
      if(anonymousCheck){
      window.config.disableSuggest=true;
      } 
      
      // if(file) {
      //   setFile(null);
      //   if (fileInputRef.current) {
      //     fileInputRef.current.value = "";
      //   }
      // }

     if (!value) {
        setTimeout(() => {
          if(window.config.disableSuggest==false){
            console.log(" window.config.disableSuggest:", String( window.config.disableSuggest))
          handleDebounce.current(value, debounceFun)
          }
        }, 300);
      }
      if( window.config.disableSuggest==false){
      handleDebounce.current(DOMPurify.sanitize(value), debounceFun);  
      } 
      setSendBoxValue(value);
      
      // clearing any previous typing event
      if (typingTimeout) {
        clearTimeout(typingTimeout)
      }
      // creating typing event after detecting typing event for 6s duration
      setTypingTimeout(
        setTimeout(() => {
          // sending event only when agent is live.
          if (window.config.businessUnit === "HBT-GCEGBT" && context.isLiveAgent) {
            window.config.showTypingIndicator = false;
            sendEvent("customerTypingIndicationToAgent", { isCustomerTyping: false });
          }

        }, 2500)
      )
     
    },
    [file,sendBoxValue, setSendBoxValue]
  );

  // useEffect to keep on checking if user is typing or not.
  useEffect(() => {
    if (sendBoxValue) {
      // detecting customer is typing so disabling typing indicator if any
      // creating typing true event
      var timer = setTimeout(() => {
        if (window.config.businessUnit === "HBT-GCEGBT" && context.isLiveAgent) {
          sendEvent("customerTypingIndicationToAgent", { isCustomerTyping: true })
        }
      }, 500)
    }
    return () => {
      clearTimeout(timer)
    }
  }, [sendBoxValue])

  const handleFocusSendBox = useCallback(() => {
    if (window.config.businessUnit !== "HCE-MARKETING") {
       if (textInput.current) {
      textInput.current.focus();
       }
    }
  }, [textInput]);

  const handleSubmit = useCallback(
    async (event) => {
      // disabling typing indicator for any accidental issues.
      if (window.config.businessUnit === "HBT-GCEGBT" && context.isLiveAgent) {
        window.config.showTypingIndicator = false;

        setTimeout(() => {
          window.config.showTypingIndicator = true;
        }, 5000)
      }
      let value = event ? event.preventDefault() : "";
      if (file) {
         const sizeTitle=window.config.language ? StaticLabels[window.config.language].sizeTitle : StaticLabels["en"].sizeTitle;
         const typeTitle=window.config.language ? StaticLabels[window.config.language].typeTitle : StaticLabels["en"].typeTitle;
         const systemTitle=window.config.language ? StaticLabels[window.config.language].systemTitle : StaticLabels["en"].systemTitle;
        const sizeMessage=window.config.language ? StaticLabels[window.config.language].sizeMessage : StaticLabels["en"].sizeMessage;
        const typeMessage=window.config.language ? StaticLabels[window.config.language].typeMessage : StaticLabels["en"].typeMessage;
        const systemMessage=window.config.language ? StaticLabels[window.config.language].systemMessage : StaticLabels["en"].systemMessage;
        const caseId = context.sessionId || '';
        const apiUrl = window.config.uploadFeature+ window.config["2369836556746c696e650808"].split("&=")[1];
        const inputEl = fileInputRef.current;
        const textEl  = textInputRef.current;

        const MAX_FILE_SIZE = 4 * 1024 * 1024;

        if (file.size > MAX_FILE_SIZE) {
          setUploadNotice({
            kind: "size",
            title:sizeTitle,
            body: sizeMessage
          });
          setSendBoxValue('');
          context.setDisableSendBox(false);
          setFile(null)
          return;
        }

        try {
          context.setDisableSendBox(true);

          const result = await sendToUploadAPI({ file, caseId, apiUrl });

          if (result.ok) {
            const isImage = /^image\//.test(file.type);
            const url = URL.createObjectURL(file);
            setFile(null);
            if (inputEl) inputEl.value = '';
            if (textEl) textEl.value = '';
            setTimeout(() => URL.revokeObjectURL(url), 60000);

            const base64 = await fileToBase64(file);
            const dataUrl = `data:${file.type};base64,${base64}`;

            const attachmentRecord = {
              id: Date.now().toString(),
              name: file.name,
              isImage,
              contentType: file.type,
              contentUrl: isImage?dataUrl:"ab",
              timestamp: new Date().toISOString(),
            };

            // setPersistedAttachments(prev => {
            //   const updated = [...prev, attachmentRecord];
            //   savePersistedAttachments(updated);
            //   return updated;
            // })
            // const submissionMessage=window.config.language ? StaticLabels[window.config.language].attachmentsubMission : StaticLabels["en"].attachmentsubMission 
            // setTimeout(()=>{
            // sendMessage(submissionMessage);
            // },0);  
            const updateAttachmentsPromise = new Promise((resolve) => {
              setPersistedAttachments((prev) => {
                const updated = [...prev, attachmentRecord];
                savePersistedAttachments(updated);
                resolve(); // Resolve the promise after the state update
                return updated;
              });
            });

            // Wait for the state update to complete, then send the submission message
            await updateAttachmentsPromise.then(()=>{
              console.log("added")
   const submissionMessage = window.config.language
              ? StaticLabels[window.config.language].attachmentsubMission
              : StaticLabels['en'].attachmentsubMission;
            sendMessage(submissionMessage); // Send message after UI update is complete
            
            })

         
          } else {
            console.log(result.code,"..22code")
           setUploadNotice(mapErrorCodeToBanner(result.code,sizeTitle,sizeMessage,typeTitle,typeMessage,systemTitle,systemMessage));
          }
          // context.setDisableSendBox(false);
          // setSendBoxValue('')
          // setFile(null)
        } catch {
            console.log("..11code")
          setUploadNotice(mapErrorCodeToBanner('system',sizeTitle,sizeMessage,typeTitle,typeMessage,systemTitle,systemMessage));
        } finally {
          context.setDisableSendBox(false);
          setSendBoxValue('')
          setFile(null)
      }
      return;
      }
      value = "";
      context.setMenuOpen(false);
      context.setMoreOptionsClick(false);
      if (context.isLiveAgent) {
        context.setDisableSendBox(false);
      }
      else {
        if (getCookie(window.config.businessUnit + '-EnableSendBox')) {
          sendEvent('enableSendBoxEventReceived');
        }
        context.setDisableSendBox(true);
      }
      setLastMessage(DOMPurify.sanitize(sendBoxValue));
      scrollDown(bodyRef);
      const messageText = sendBoxValue.trim();
      sendMessage(DOMPurify.sanitize(messageText));
      setSendBoxValue(value);
      setUploadNotice(null);
      setSearchResult([]);
      setTimeout(() => handleDebounce.current(value, debounceFun), 300);
      // sendMessage("");
    },
    [sendBoxValue, sendMessage, setSendBoxValue, setSearchResult, file, context, setFile, setUploadNotice]
  );
   const handleKeyDown = (event) => {
      // Check if the pressed key is 'Enter' and if the Shift key is NOT also pressed
      // This prevents submitting on Shift + Enter, which is often used for new lines
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault(); // Prevent the default new line behavior in the textarea
        handleSubmit(); // Call your submit function
      }
      else if (event.key === 'Backspace' && file?.name) {
       setSendBoxValue("");
        setFile(null);
       }
  };
 

  const handleSuggestedInputSelection = useCallback(
    data => event => {
       if (textInput.current) {
      textInput.current.focus();
       }
      context.setMoreOptionsClick(false);
      setSearchResult([]);
      const messageText = data.suggestedText.replace(/\**/gi, "");
      if (data.intent) {
        sendMessageBack(`suggestedInput-${data.intent}`, messageText, messageText);
      } else {
        sendMessage(messageText);
      }
      handleDebounce.current("");
      sendMessage("");
      setSendBoxValue("");
      if (context.isLiveAgent) {
        context.setDisableSendBox(false);
      }
      else {
        if (getCookie(window.config.businessUnit + '-EnableSendBox')) {
          sendEvent('enableSendBoxEventReceived');
        }
        context.setDisableSendBox(true);
      }
    },
    [sendMessage]
  );

  var webchatClass = classNames({
    webChat: true,
    customscrollbar: true,
    displayNone: !isMaximised,
    displayNoneHBT: window.config.isLoaderShow && !window.config.isBrandBasedPage ?context.showSpinnerWheelOnLoad:false,
    webChatScroll: context.enableScroll,
    webChatScrollAgent:context.isLiveAgent && window.config.isNewUI && !isSurveyOpen && !context.transcriptTranslationRequired,
    webChatScrollAgenttranslation:context.isLiveAgent && window.config.isNewUI && !isSurveyOpen && context.transcriptTranslationRequired
  });

  var LiveAgentImgPositionClass = classNames({
    LiveAgentImgPosition: true,
    displayNone: !isMaximised
  });

  var sendBoxContainerClass = classNames({
    "send-box-container": true,
    displayNone: !isMaximised,
    sendBox_HBT: window.config.isNewUI ? true : false
  });

  var sendBoxMenuIcon = classNames({
    sendBoxMenuIcon: true,
    displayNone: !isMaximised || window.config.hideTextBox
  });

  var suggestedInputClass = classNames({
    suggestedInputContainer: true,
    customscrollbar: true,
    displayNone: !isMaximised
  });

  var sendBoxDisableClass = classNames({
    'send-box-input': true,
    disableSendBox: true
  });

  var hbtMargin = classNames({
    hbtMargin: window.config.sbg === "HBT"
  });

  const handleMenuClick = () => {
    context.setMenuOpen(!context.menuOpen);
  };

  const closeMenuClick = () => {
    context.setMenuOpen(false);
  };

  const menuOptionsClick = () => {
    context.setMenuOpen(false);
    sendMessage("Menu");
  };

  const liveAgentOptionClick = () => {
    context.setMenuOpen(false);
    context.setDisableSendBox(true);
    const message=window.config.language ? StaticLabels[window.config.language].LiveAgent :"live agent";
    sendMessage(message);
  }
const businessUnit = window.config.businessUnit;
  return (
    <React.Fragment>
      {
        window.config.isLoaderShow && !window.config.isBrandBasedPage ?
          <>{context.showSpinnerWheelOnLoad ? <div style={{ padding: 5, height: "100%" }}><Spinner
          isMaximised={isMaximised}
          showSpinner={(isMaximised = { isMaximised })}
          handleModalChange={handleModalChange}
        /></div> : null}
            <div ref={bodyRef} className={webchatClass} id="web-chat">
              <ul className="welcomecardBotDivHeight">
                {
                  activitiesWithPreview
                    // Currently, this sample only displays an activity of type "message"
                    .filter(({ type }) => type === "message")
                    // We need to hide "postBack" message sent by the user
                    .filter(
                      ({ channelData: { postBack } = {}, from: { role } }) =>
                        !(role === "user" && postBack)
                    )
                    // Normalize the activity:
                    // - Every activity should have an "attachments" array, consisting of zero or more attachments:
                    // - If this is a "messageBack" message, we should use the "displayText",
                    //   because "text" is being submitted to bot, and "displayText" is what we use to override what the bot displays to the user.
                    .map(activity => ({
                      ...activity,
                      attachments: activity.attachments || [],
                      text:
                        getValueOrUndefined(
                          activity,
                          "channelData",
                          "messageBack",
                          "displayText"
                        ) || activity.text
                    }))
                    // Filter out all empty messages (no attachments or text)
                    .filter(({ attachments, text }) => attachments.length || text)
                    .map((activity, index) => (
                      context.setShowSpinnerWheelOnload(false),
                      <React.Fragment key={activity.id || index}>
                        {scrollDown(bodyRef)}
                        <></>
                        <li className="botDivHeight">
                          {!!activity.text && (
                            // We are using the very same component for text message and attachments.
                            // This is because, attachments can also have "text/markdown" or "text/plain" content.
                            // In this case, we prefer to have a single component for both of them.
                            <div>
                              <Attachment
                                index={index}
                                content={activity.text}
                                contentType={
                                  activity.textFormat === "markdown"
                                    ? "text/markdown"
                                    : "text/plain"
                                }
                                // from={
                                //   isLiveAgent === false
                                //     ? activity.from.role
                                //     : "agent"
                                // }
                                //from= {activity.from.role === "user" ? "user": (isLiveAgent === false ?"bot":"agent") }
                                from={activity.from.role}
                                timestamp={activity.timestamp}
                                suggestedActions={activity.suggestedActions}
                                activity={activity}
                                attachments={activity.attachments}
                                inputHint={activity.inputHint}
                                isLiveAgent={isLiveAgent}
                                setLiveAgent={setLiveAgent}
                                handleModalChange={handleModalChange}
                                userLanguage={userLanguage}
                                headerRef={headerRef}
                              ></Attachment>
                            </div>
                          )}
                          {!!activity.attachments.length && (
                            <ul className="botDivHeight">
                              {activity.attachments.map((attachment, index) => (
                                <li className="botDivHeight" key={index}>
                                  <Attachment
                                    index={index}
                                    activity={activity}
                                    userLanguage={userLanguage}
                                    headerRef={headerRef}
                                    attachments={activity.attachments}
                                    handleModalChange={handleModalChange}
                                    handleMaximizeChange={handleMaximizeChange}
                                    handleCloseModalPopup={handleCloseModalPopup}
                                    timestamp={activity.timestamp}
                                    {...attachment}
                                  />
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      </React.Fragment>
                    ))
                }
                <SuggestedActions handleFocusSendBox={handleFocusSendBox} userLanguage={userLanguage} />
                {!showTimerBox && context.enableScroll && !isEmpty(typingIndicator) && window.config.showTypingIndicator ? (
                  <li>
                    <div>
                      <div>
                        <div className={"typingIndicator"}>
                          {context.isLiveAgent === false && !window.config.isNewUI &&
                            <div className={Icon}></div>}
                          {context.isLiveAgent && !window.config.isNewUI &&
                            <div className={liveAgentIcon}>
                              {context.liveAgentName.toUpperCase().substring(0, 1)}
                            </div>
                          }
                          {/* <div className={botAvatar}>
                      <Components.Avatar height={20} fromUser={false} />
                    </div> */}

                          <div className="dot">
                            <div className="dot-flashing"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </div>
            {scrollDown(bodyRef)}
            {/* {context.enableScroll && window.config.sbg === "PMT" && window.config.gbe === "AMRC" ? (
        <div className={LiveAgentImgPositionClass}>
          <iframe
            src="./LiveAgent.html"
            width="160px"
            height="80px"
            style={{ border: "none", float: "right" }}
          />
        </div>
      ) : (
        ""
      )} */}
            {showTimerBox && window.config.businessUnit === "HBT-GCEGBT" &&
              <TimerBoxHBT
                isMaximised={isMaximised}
                handleModalChange={handleModalChange}
                showTimerBox={showTimerBox}
                setShowTimerBox={setShowTimerBox}
                handleSurveyCardChange={handleSurveyCardChange}
                setHeaderIconsDisplay={setHeaderIconsDisplay}
                setLiveAgent={setLiveAgent}
              >
              </TimerBoxHBT>
            }
            {showTimerBox && window.config.businessUnit !== "HBT-GCEGBT" &&
              <TimerBox_Main
                isMaximised={isMaximised}
                handleModalChange={handleModalChange}
                showTimerBox={showTimerBox}
                setShowTimerBox={setShowTimerBox}
                handleSurveyCardChange={handleSurveyCardChange}
                setHeaderIconsDisplay={setHeaderIconsDisplay}
                setLiveAgent={setLiveAgent}
              >
              </TimerBox_Main>
            }
            {context.showSendBox && window.config.isNewUI &&
              <div className={sendBoxMenuIcon}>
                
                <div className="composer-stack">
                 {uploadNotice && (
                      <div className={`upload-banner ${uploadNotice.kind}`} role="status" aria-live="polite">
                        {/* <img 
                          className="upload-icon" 
                          aria-hidden="true"src={systemErrorIcon} 
                          alt="">
                          </img> */}
                        <div className="upload-copy">
                          <div className={`upload-title ${uploadNotice.kind}`}>{uploadNotice.title}</div>
                          <div className={`upload-body ${uploadNotice.kind}`}>{uploadNotice.body}</div>
                        </div>
                      </div>
                    )}
                  <div className="composer-row">
                <div className="menuIcon">
                  <img
                    alt="MenuIcon"
                    src={MenuIcon}
                    onClick={handleMenuClick}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
                <div className={sendBoxContainerClass}>
                  {(searchResult.length && (context.enableSendBoxHBT || !context.disableSendBox) && !context.isLiveAgent ? (
                    <div className={suggestedInputClass}>
                      <ul>
                        {searchResult.map((data, index) => (
                          <li key={index}>
                            <button
                              className="suggestedInputButton"
                              key={index}
                              onClick={handleSuggestedInputSelection(data)}
                            >
                              <p className="suggestedInputImage" />
                              <p className="suggestedInputData">
                                <Markdown>{data.suggestedText}</Markdown>
                              </p>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null)}
                  <div className="send-box">
                    {/* This is the send box, and suggested actions change based on the send box, not activity */}
                    {/* <SendBox/> */}
                    <input className="send-box-preview"
                   ref={fileInputRef}
                   type="file"
                   style={{ display: 'none' }}
                   accept=".csv,.doc,.docx,.dot,.ics,.pdf,.pps,.ppsx,.ppt,.pptx,.rtf,
                    .sxc,.sxi,.sxw,.txt,.xls,.xlsx,
                    .vsd,.gif,.jpeg,.jpg,.png,
                    .mp3,.ogg,.wav,
                    .avi,.mov,.mpeg,.mpg,.mp4"
                   onChange={onFilePick}
                   />
                    {context.isLiveAgent
                           //&& !window.config.isChina && isAuthenticated && anonymousCheck 
                          && (
                            <>
                              {(!context.disableSendBox ?
                               <AttachmentFile fileInputRef={fileInputRef}  onFilePick={onFilePick}/>
                                :
                                null
                              )}
                            </>
                          )}
                    <form onSubmit={handleSubmit} className={hbtMargin}>
                    {/* {context.isLiveAgent
                           //&& !window.config.isChina && isAuthenticated && anonymousCheck 
                          && (
                            <>
                              {(!context.disableSendBox ?
                               <AttachmentFile fileInputRef={fileInputRef}  onFilePick={onFilePick}/>
                                :
                                null
                              )}
                            </>
                          )} */}

                      {(context.enableSendBoxHBT || !context.disableSendBox ?
                         window.config.charLimit && isMaximised && !context.isLiveAgent && (context.enableSendBoxHBT || !context.disableSendBox)?<CharCounterInput  ref={textInput}  handleKeyDown={handleKeyDown} placeholder={
                            context.isLiveAgent === false
                              ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                                (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversation : "Write a message to Honeywell Assist")
                              : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                          }
                          className="send-box-input"
                          autoFocus={true}
                          onChange={handleChange}
                          type="textbox"
                          value={sendBoxValue}
                          maxLength={250}/>:window.config.isTextArea?<textarea
                          ref={textInput}
                          onKeyDown={handleKeyDown}
                          placeholder={
                            context.isLiveAgent === false
                              ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                                (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversation : "Write a message to Honeywell Assist")
                              : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                          }
                          className={file?"send-box-input attachedFile":"send-box-input"}
                          autoFocus={true}
                          onChange={handleChange}
                          name="textarea"
                          value={sendBoxValue}
                          maxLength={500}
                        />:<input
                          ref={textInput}
                          placeholder={
                            context.isLiveAgent === false
                              ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                                (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversation : "Write a message to Honeywell Assist")
                              : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                          }
                          className={`send-box-input ${context.isLiveAgent ? 'send-box-input-live' : 'send-box-input-bot'}`}
                          autoFocus={true}
                          onChange={handleChange}
                          type="textbox"
                          value={sendBoxValue}
                          maxLength={500}
                        /> :
                        <input
                          ref={textInput}
                          className={sendBoxDisableClass}
                          value=""
                          type="textbox"
                          disabled
                        />)}
                    </form>
                  </div>
                  {(context.enableSendBoxHBT || !context.disableSendBox ? <button onClick={handleSubmit} className="send-box-button"></button> : null)}
                </div>
                  </div>
                </div>

              </div>}
            {window.config.isDisclaimer && !context.chatleftStart && !context.isLiveAgent && isMaximised && (context.enableSendBoxHBT || !context.disableSendBox) ?<div className="aiSummaryContainer"><span></span><p className="privacyPara aisummary"><span>{window.config.language? window.config.businessUnit === "HBT-GCEGBT" ? StaticLabels[window.config.language].summaryTextBA:StaticLabels[window.config.language].summaryTextAero:StaticLabels["en"].summaryTextAero}</span></p><span>{window.config.isTextArea?<div  className={textAreaMaxLimit}>
              {sendBoxValue.length}/{250}
            </div>:null}</span></div>:null}
            {context.showSendBox && !window.config.isNewUI && (
              <div className={sendBoxContainerClass}>
                {(searchResult.length && !context.disableSendBox ? (
                  <div className={suggestedInputClass}>
                    <ul>
                      {searchResult.map((data, index) => (
                        <li key={index}>
                          <button
                            className="suggestedInputButton"
                            key={index}
                            onClick={handleSuggestedInputSelection(data)}
                          >
                            <p className="suggestedInputImage" />
                            <p className="suggestedInputData">
                              <Markdown>{data.suggestedText}</Markdown>
                            </p>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null)}

                <div className="send-box">
                  {/* This is the send box, and suggested actions change based on the send box, not activity */}
                  {/* <SendBox/> */}
                  {/* <p>Hii</p> */}
                  <div className="send-box-attachments" >
                    {context.isLiveAgent && (
                      <>
                        {context.disableSendBox ?
                          <button
                            type="button"
                            className={attachClass}
                            onClick={() => fileInputRef.current?.click()}
                            aria-label="Attach file"
                            disabled
                          >
                            <img src={AttachmentIcon} alt="Attach" className="attach-icon" />
                          </button>
                          :
                         <AttachmentFile fileInputRef={fileInputRef}  onFilePick={onFilePick}/>
                         }
                      </>
                    )}
                  </div>

                  <form onSubmit={handleSubmit} className={hbtMargin}>        

                    {(!context.disableSendBox ?
                       window.config.charLimit && isMaximised && !context.isLiveAgent && (context.enableSendBoxHBT || !context.disableSendBox)?<CharCounterInput ref={textInput}  handleKeyDown={handleKeyDown}
                        placeholder={
                          context.isLiveAgent === false
                            ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                              (userLanguage ? (context.restrictTextBox ? StaticLabels[userLanguage.toLowerCase()].StartConversationNumber : StaticLabels[userLanguage.toLowerCase()].StartConversation) : (context.restrictTextBox ? "Please enter only numbers" : "Write a message to Honeywell Assist"))
                            : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                        }
                        className={file?"send-box-input attachedFile":"send-box-input"}
                        autoFocus={true}
                        onChange={handleChange}
                        type={window.config.businessUnit === "SPS-ECOMM" ? (context.restrictTextBox ? "number" : "textbox") : "textbox"}
                        value={sendBoxValue}
                        maxLength={250}/>:window.config.isTextArea?<textarea
                        ref={textInput}
                        onKeyDown={handleKeyDown}
                        placeholder={
                          context.isLiveAgent === false
                            ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                              (userLanguage ? (context.restrictTextBox ? StaticLabels[userLanguage.toLowerCase()].StartConversationNumber : StaticLabels[userLanguage.toLowerCase()].StartConversation) : (context.restrictTextBox ? "Please enter only numbers" : "Write a message to Honeywell Assist"))
                            : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                        }
                        className="send-box-input"
                        autoFocus={true}
                        onChange={handleChange}
                        name="textarea"
                        value={sendBoxValue}
                        maxLength={500}
                      />:<input
                        ref={textInput}
                        placeholder={
                          context.isLiveAgent === false
                            ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                              (userLanguage ? (context.restrictTextBox ? StaticLabels[userLanguage.toLowerCase()].StartConversationNumber : StaticLabels[userLanguage.toLowerCase()].StartConversation) : (context.restrictTextBox ? "Please enter only numbers" : "Write a message to Honeywell Assist"))
                            : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                        }
                        className="send-box-input"
                        autoFocus={true}
                        onChange={handleChange}
                        type={window.config.businessUnit === "SPS-ECOMM" ? (context.restrictTextBox ? "number" : "textbox") : "textbox"}
                        value={sendBoxValue}
                        maxLength={500}
                      /> :
                      <input
                        ref={textInput}
                        className={sendBoxDisableClass}
                        value=""
                        type="textbox"
                        disabled
                      />)}

                  </form>
                </div>

                {(!context.disableSendBox ? <button onClick={handleSubmit} className="send-box-button"></button> : null)}

              </div>)
            }
            {
              (context.menuOpen && window.config.isNewUI) &&
              <div className='menuContainer_HBT'>
                {/* {!context.isLiveAgent && !context.hideStickyMenu && <p onClick={menuOptionsClick}><img alt="SupportOptions" src={SupportOptions_HBT} /> {liveAgentStaticLabels[window.config.language].SupportOptions} </p>} */}
                <p onClick={handleModalChange({
                  isOpenModal: true,
                  value: null,
                  target: "refresh"
                })}><img alt="Restart" src={Restart_HBT} /> {window.config.businessUnit === 'HBT-GCEGBT' ? StaticLabels[window.config.language].RestartChat : 'Restart Chat'} </p>
                {
                window.config.businessUnit === 'HBT-GCEGBT' && !context.isLiveAgent && !showTimerBox && !context.hideStickyMenu && !isValidAnonymousPageTitle && !isNoLiveAgentChat && <p onClick={liveAgentOptionClick}><img alt="LiveAgent" src={LiveAgent_HBT} /> {
                  window.config.businessUnit === 'HBT-GCEGBT' ?
                    StaticLabels[window.config.language].LiveAgent : 'Live Agent'} </p>
                    }
                <p onClick={closeMenuClick}> <img alt="Close" src={CloseMenu_HBT} /> {window.config.businessUnit === 'HBT-GCEGBT' ? StaticLabels[window.config.language].CloseMenu : 'Close Menu'} </p>
              </div>

            }
          </> :
          <><div ref={bodyRef} className={webchatClass} id="web-chat">
            <ul className="welcomecardBotDivHeight">
              {
                activitiesWithPreview
                  // Currently, this sample only displays an activity of type "message"
                  .filter(({ type }) => type === "message")
                  // We need to hide "postBack" message sent by the user
                  .filter(
                    ({ channelData: { postBack } = {}, from: { role } }) =>
                      !(role === "user" && postBack)
                  )
                  // Normalize the activity:
                  // - Every activity should have an "attachments" array, consisting of zero or more attachments:
                  // - If this is a "messageBack" message, we should use the "displayText",
                  //   because "text" is being submitted to bot, and "displayText" is what we use to override what the bot displays to the user.
                  .map(activity => ({
                    ...activity,
                    attachments: activity.attachments || [],
                    text:
                      getValueOrUndefined(
                        activity,
                        "channelData",
                        "messageBack",
                        "displayText"
                      ) || activity.text
                  }))
                  // Filter out all empty messages (no attachments or text)
                  .filter(({ attachments, text }) => attachments.length || text)
                  .map((activity, index, previewActivity) => (
                    <React.Fragment key={activity.id || index}>
                      {scrollDown(bodyRef)}
                      <></>
                      <li className="botDivHeight">
                        {!!activity.text && (
                          // We are using the very same component for text message and attachments.
                          // This is because, attachments can also have "text/markdown" or "text/plain" content.
                          // In this case, we prefer to have a single component for both of them.
                          <div>
                            <Attachment
                              index={index}
                              content={activity.text}
                              contentType={
                                activity.textFormat === "markdown"
                                  ? "text/markdown"
                                  : "text/plain"
                              }
                              // from={
                              //   isLiveAgent === false
                              //     ? activity.from.role
                              //     : "agent"
                              // }
                              //from= {activity.from.role === "user" ? "user": (isLiveAgent === false ?"bot":"agent") }
                              from={activity.from && activity.from.role}
                              timestamp={activity.timestamp}
                              suggestedActions={activity.suggestedActions}
                              activity={activity}
                              attachments={activity.attachments}
                              inputHint={activity.inputHint}
                              isLiveAgent={isLiveAgent}
                              setLiveAgent={setLiveAgent}
                              handleModalChange={handleModalChange}
                              userLanguage={userLanguage}
                              headerRef={headerRef}
                            ></Attachment>
                          </div>
                        )}
                        {!!activity.attachments.length && (
                          <ul className="botDivHeight">
                            {activity.attachments.map((attachment, index) => (
                              <li className="botDivHeight" key={index}>
                                <Attachment
                                  from={activity.from && activity.from.role}
                                  index={index}
                                  activity={activity}
                                  userLanguage={userLanguage}
                                  headerRef={headerRef}
                                  attachments={activity.attachments}
                                  handleModalChange={handleModalChange}
                                  handleMaximizeChange={handleMaximizeChange}
                                  handleCloseModalPopup={handleCloseModalPopup}
                                  timestamp={activity.timestamp}
                                  {...attachment}
                                />
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    </React.Fragment>
                  ))
              }
              <SuggestedActions handleFocusSendBox={handleFocusSendBox} userLanguage={userLanguage} />
              {!showTimerBox && context.enableScroll && !isEmpty(typingIndicator) && window.config.showTypingIndicator ? (
                <li>
                  <div>
                    <div>
                      <div className={"typingIndicator"}>
                        {context.isLiveAgent === false && !window.config.isNewUI &&
                          <div className={Icon}></div>}
                        {context.isLiveAgent && !window.config.isNewUI &&
                          <div className={liveAgentIcon}>
                            {context.liveAgentName.toUpperCase().substring(0, 1)}
                          </div>
                        }
                        {/* <div className={botAvatar}>
                      <Components.Avatar height={20} fromUser={false} />
                    </div> */}

                        <div className="dot">
                          <div className="dot-flashing"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
            {scrollDown(bodyRef)}
            {/* {context.enableScroll && window.config.sbg === "PMT" && window.config.gbe === "AMRC" ? (
        <div className={LiveAgentImgPositionClass}>
          <iframe
            src="./LiveAgent.html"
            width="160px"
            height="80px"
            style={{ border: "none", float: "right" }}
          />
        </div>
      ) : (
        ""
      )} */}
            {showTimerBox && window.config.businessUnit === "HBT-GCEGBT" &&
              <TimerBoxHBT
                isMaximised={isMaximised}
                handleModalChange={handleModalChange}
                showTimerBox={showTimerBox}
                setShowTimerBox={setShowTimerBox}
                handleSurveyCardChange={handleSurveyCardChange}
                setHeaderIconsDisplay={setHeaderIconsDisplay}
                setLiveAgent={setLiveAgent}
              >
              </TimerBoxHBT>
            }
            {showTimerBox && window.config.businessUnit !== "HBT-GCEGBT" &&
              <TimerBox_Main
                isMaximised={isMaximised}
                handleModalChange={handleModalChange}
                showTimerBox={showTimerBox}
                setShowTimerBox={setShowTimerBox}
                handleSurveyCardChange={handleSurveyCardChange}
                setHeaderIconsDisplay={setHeaderIconsDisplay}
                setLiveAgent={setLiveAgent}
              >
              </TimerBox_Main>
            }
            {context.showSendBox && window.config.isNewUI &&
              <div className={sendBoxMenuIcon}>
                {/* <div className="menuIcon">
                  <img
                    alt="MenuIcon"
                    src={MenuIcon}
                    onClick={handleMenuClick}
                    style={{ cursor: 'pointer' }}
                  />
                </div> */}
                <div className="composer-stack">
                 {uploadNotice && (
                      <div className={`upload-banner ${uploadNotice.kind}`} role="status" aria-live="polite">
                          {/* <img 
                          className="upload-icon" 
                          aria-hidden="true"src={systemErrorIcon} 
                          alt="">
                          </img> */}
                        <div className="upload-copy">
                          <div className={`upload-title ${uploadNotice.kind}`}>{uploadNotice.title}</div>
                          <div className={`upload-body ${uploadNotice.kind}`}>{uploadNotice.body}</div>
                        </div>
                      </div>
                    )}
                    <div className="composer-row">
                      <div className="menuIcon">
                        <img
                          alt="MenuIcon"
                          src={MenuIcon}
                          onClick={handleMenuClick}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                <div className={sendBoxContainerClass}>
                  {(searchResult.length && (context.enableSendBoxHBT || !context.disableSendBox) && !context.isLiveAgent ? (
                    <div className={suggestedInputClass}>
                      <ul>
                        {searchResult.map((data, index) => (
                          <li key={index}>
                            <button
                              className="suggestedInputButton"
                              key={index}
                              onClick={handleSuggestedInputSelection(data)}
                            >
                              <p className="suggestedInputImage" />
                              <p className="suggestedInputData">
                                <Markdown>{data.suggestedText}</Markdown>
                              </p>
                            </button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : null)}
                  <div className="send-box">
                    {/* This is the send box, and suggested actions change based on the send box, not activity */}
                    {/* <SendBox/> */}
                   {/* <p>Hii1</p> */}
                      {context.disableSendBox ?
                        <button
                          type="button"
                          className={attachClass}
                          onClick={() => fileInputRef.current?.click()}
                          aria-label="Attach file"
                          disabled
                        >
                          <img src={AttachmentIcon} alt="Attach" className="attach-icon" />
                        </button>
                        :
                        <AttachmentFile fileInputRef={fileInputRef}  onFilePick={onFilePick}/>}
                    <form onSubmit={handleSubmit} className={hbtMargin}>
                      {(context.enableSendBoxHBT || !context.disableSendBox ?
                        window.config.charLimit && isMaximised && !context.isLiveAgent && (context.enableSendBoxHBT || !context.disableSendBox)?<CharCounterInput ref={textInput}  handleKeyDown={handleKeyDown}
                          placeholder={
                            context.isLiveAgent === false
                              ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                                (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversation : "Write a message to Honeywell Assist")
                              : context.liveAgentName ? StaticLabels[userLanguage.toLowerCase()].StartConversationAgent + context.liveAgentName : StaticLabels[userLanguage.toLowerCase()].StartConversationLiveAgent
                          }
                          className="send-box-input"
                          autoFocus={true}
                          onChange={handleChange}
                          type="textbox"
                          value={sendBoxValue}
                          maxLength={250}/>:window.config.isTextArea?<textarea
                          ref={textInput}
                          onKeyDown={handleKeyDown}
                          placeholder={context.isLiveAgent === false
                              ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                                (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversation : "Write a message to Honeywell Assist")
                              : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                          }
                          name="textarea"
                          className={file?"send-box-input attachedFile":"send-box-input"}
                          autoFocus={true}
                          onChange={handleChange}
                          value={sendBoxValue}
                          maxLength={500}
                        />:window.config.isTextArea?<textarea
                          ref={textInput}
                           onKeyDown={handleKeyDown}
                          placeholder={
                            context.isLiveAgent === false
                              ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                                (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversation : "Write a message to Honeywell Assist")
                              : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                          }
                          className="send-box-input"
                          autoFocus={true}
                          onChange={handleChange}
                          name="textarea"
                          value={sendBoxValue}
                          maxLength={500}
                        />:<input
                          ref={textInput}
                          placeholder={
                            context.isLiveAgent === false
                              ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                                (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversation : "Write a message to Honeywell Assist")
                              : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                          }
                          className="send-box-input"
                          autoFocus={true}
                          onChange={handleChange}
                          type="textbox"
                          value={sendBoxValue}
                          maxLength={500}
                        /> :
                        <input
                          ref={textInput}
                          className={sendBoxDisableClass}
                          value=""
                          type="textbox"
                          disabled
                        />)}
                    </form>
                  </div>
                  {(context.enableSendBoxHBT || !context.disableSendBox ? <button onClick={handleSubmit} className="send-box-button"></button> : null)}
                </div>
                </div>
                </div>
              </div>}
           {window.config.isDisclaimer && !context.chatleftStart && !context.isLiveAgent && isMaximised && (context.enableSendBoxHBT || !context.disableSendBox) ?<div className="aiSummaryContainer"><span></span><p className="privacyPara aisummary"><span>{window.config.language? window.config.businessUnit === "HBT-GCEGBT" ? StaticLabels[window.config.language].summaryTextBA:StaticLabels[window.config.language].summaryTextAero:StaticLabels["en"].summaryTextAero}</span></p><span>{window.config.isTextArea?<div  className={textAreaMaxLimit}>
              {sendBoxValue.length}/{250}
            </div>:null}</span></div>:null}
            {context.showSendBox && !window.config.isNewUI && (
              <div className="composer-stack">
                {uploadNotice && (
                      <div className={`upload-banner ${uploadNotice.kind}`} role="status" aria-live="polite">
                        {/* <img 
                          className="upload-icon" 
                          aria-hidden="true"src={systemErrorIcon} 
                          alt="">
                          </img> */}
                        <div className="upload-copy">
                          <div className={`upload-title ${uploadNotice.kind}`}>{uploadNotice.title}</div>
                          <div className={`upload-body ${uploadNotice.kind}`}>{uploadNotice.body}</div>
                        </div>
                      </div>
                    )}
              <div className={sendBoxContainerClass}>
                {(searchResult.length && !context.disableSendBox ? (
                  <div className={suggestedInputClass}>
                    <ul>
                      {searchResult.map((data, index) => (
                        <li key={index}>
                          <button
                            className="suggestedInputButton"
                            key={index}
                            onClick={handleSuggestedInputSelection(data)}
                          >
                            <p className="suggestedInputImage" />
                            <p className="suggestedInputData">
                              <Markdown>{data.suggestedText}</Markdown>
                            </p>
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null)}
                <div className="send-box">
                  {/* This is the send box, and suggested actions change based on the send box, not activity */}
                  {/* <SendBox/> */}
                  
                    {/* {context.disableSendBox ?
                       <button
                        type="button"
                        className="attach-btn"
                        onClick={() => fileInputRef.current?.click()}
                        aria-label="Attach file"
                        disabled
                      >
                        <img src={AttachmentIcon} alt="Attach" className="attach-icon" />
                      </button>
                      : */}
                    <AttachmentFile fileInputRef={fileInputRef}  onFilePick={onFilePick}/>
                  <form onSubmit={handleSubmit} className={hbtMargin}>

                    {(!context.disableSendBox ?
                       window.config.charLimit && isMaximised && !context.isLiveAgent && (context.enableSendBoxHBT || !context.disableSendBox)?<CharCounterInput  ref={textInput}  handleKeyDown={handleKeyDown}
                        placeholder={
                          context.isLiveAgent === false
                            ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                              (userLanguage ? (context.restrictTextBox ? StaticLabels[userLanguage.toLowerCase()].StartConversationNumber : StaticLabels[userLanguage.toLowerCase()].StartConversation) : (context.restrictTextBox ? "Please enter only numbers" : "Write a message to Honeywell Assist"))
                            : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                        }
                        className="send-box-input"
                        autoFocus={true}
                        onChange={handleChange}
                        type={window.config.businessUnit === "SPS-ECOMM" ? (context.restrictTextBox ? "number" : "textbox") : "textbox"}
                        value={sendBoxValue}
                        maxLength={250}/>:window.config.isTextArea?<textarea
                        ref={textInput}
                        onKeyDown={handleKeyDown}
                        placeholder={
                          context.isLiveAgent === false
                            ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                              (userLanguage ? (context.restrictTextBox ? StaticLabels[userLanguage.toLowerCase()].StartConversationNumber : StaticLabels[userLanguage.toLowerCase()].StartConversation) : (context.restrictTextBox ? "Please enter only numbers" : "Write a message to Honeywell Assist"))
                            : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                        }
                        className="send-box-input"
                        autoFocus={true}
                        name="textarea"
                        onChange={handleChange}
                        type={window.config.businessUnit === "SPS-ECOMM" ? (context.restrictTextBox ? "number" : "textbox") : "textbox"}
                        value={sendBoxValue}
                        maxLength={500}
                      />:<input
                        ref={textInput}
                        placeholder={
                          context.isLiveAgent === false
                            ? window.config.businessUnit === "HCE-TRIDIUM" ? (userLanguage ? StaticLabels[userLanguage.toLowerCase()].StartConversationTridium : "Write a message to Tridium Assist") :
                              (userLanguage ? (context.restrictTextBox ? StaticLabels[userLanguage.toLowerCase()].StartConversationNumber : StaticLabels[userLanguage.toLowerCase()].StartConversation) : (context.restrictTextBox ? "Please enter only numbers" : "Write a message to Honeywell Assist"))
                            : context.liveAgentName ? StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationAgent + context.liveAgentName : StaticLabels[window.config.textboxTranslation ? userLanguage.toLowerCase() : "en"].StartConversationLiveAgent
                        }
                        className="send-box-input"
                        autoFocus={true}
                        onChange={handleChange}
                        type={window.config.businessUnit === "SPS-ECOMM" ? (context.restrictTextBox ? "number" : "textbox") : "textbox"}
                        value={sendBoxValue}
                        maxLength={500}
                      /> :
                      <input
                        ref={textInput}
                        className={sendBoxDisableClass}
                        value=""
                        type="textbox"
                        disabled
                      />)}

                  </form>
                </div>

                {(!context.disableSendBox ? <button onClick={handleSubmit} className="send-box-button"></button> : null)}

              </div>
              </div>)
            }
            {
              (context.menuOpen && window.config.isNewUI) &&
              <div className='menuContainer_HBT'>
                {/* {!context.isLiveAgent && !context.hideStickyMenu && <p onClick={menuOptionsClick}><img alt="SupportOptions" src={SupportOptions_HBT} /> {liveAgentStaticLabels[window.config.language].SupportOptions} </p>} */}
                <p onClick={handleModalChange({
                  isOpenModal: true,
                  value: null,
                  target: "refresh"
                })}><img alt="Restart" src={Restart_HBT} /> {window.config.businessUnit === 'HBT-GCEGBT' ? StaticLabels[window.config.language].RestartChat : 'Restart Chat'} </p>
                {window.config.businessUnit === 'HBT-GCEGBT' && !context.isLiveAgent && !showTimerBox && !context.hideStickyMenu && !isValidAnonymousPageTitle && !isNoLiveAgentChat && <p onClick={liveAgentOptionClick}><img alt="LiveAgent" src={LiveAgent_HBT} /> {
                  window.config.businessUnit === 'HBT-GCEGBT' ?
                    StaticLabels[window.config.language].LiveAgent : 'Live Agent'} </p>}
                <p onClick={closeMenuClick}> <img alt="Close" src={CloseMenu_HBT} /> {window.config.businessUnit === 'HBT-GCEGBT' ? StaticLabels[window.config.language].CloseMenu : 'Close Menu'} </p>
              </div>

            }
          </>
      }
        
    </React.Fragment>
  );
};

export default PlainWebChat;